import { Tiny } from "@/components/standard/BFText"
import { TouchableOpacity } from "react-native"

export const ARGiveFeedbackButton = ({ onPress }: { onPress: () => void }) => {
  return (
    <TouchableOpacity
      testID={"arv-give-feedback-button"}
      className={"absolute left-0 p-2 px-5 bg-midnight-blue"}
      style={{
        top: 50,
        transform: [{ rotate: "-90deg" }, { translateY: -55 }],
      }}
      onPress={onPress}
    >
      <Tiny className={"text-white flex-1"}>Give Feedback &nbsp;&nbsp; ✍️</Tiny>
    </TouchableOpacity>
  )
}
